import {
  type TimelineCartStatus,
  type TimelineStatus,
} from "constants/filingsTimeline";
import { type FilingStateTypes } from "types/Models/task";
import { emptyApi } from "store/apis/emptyApi";

export type TimelineFiling = {
  uuid: string;

  filing_id: string | null;
  name: string;
  entity_id: string;
  entity_name: string | null;

  product_id: string | null;

  product_content_type_id: number | null;

  alarm_id: string | null;

  state_id: string | null;

  state_name: string | null;
  short_name: string | null;
  tax_year: number | null;
  deadline: string;
  status_bucket: TimelineStatus;
  status_display: string;

  state_type: FilingStateTypes | null;
  is_overdue: boolean;
  cart_status: TimelineCartStatus | null;
  etd: string | null;
  filed_on: string | null;
};

/** A filing plus the key that survives duplicate `uuid`s within one response. */
export type TimelineFilingRow = TimelineFiling & { rowKey: string };

export type TimelineYearStat = {
  year: number;
  filing_count: number;
  overdue_count: number;
};

export type TimelineEntityMeta = {
  uuid: string;
  name: string;
  incorporation_year: number;

  year_stats: TimelineYearStat[];
};

export type FilingsTimelineMeta = {
  today: string;
  entities: TimelineEntityMeta[];
};

export type FilingsTimelineRows = {
  year: number;
  filings: TimelineFiling[];
};

export const filingsTimelineApi = emptyApi.injectEndpoints({
  endpoints: (build) => ({
    getFilingsTimelineMeta: build.query<
      FilingsTimelineMeta,
      { groupId: string }
    >({
      query: ({ groupId }) =>
        `/api/inkle/tax_compliance/group/${groupId}/filings_timeline/meta/`,

      providesTags: ["Tasks", "TaskList", "CART"],
    }),

    getFilingsTimeline: build.query<
      FilingsTimelineRows,
      { groupId: string; year: number; entityIds: string[] }
    >({
      query: ({ groupId, year, entityIds }) => ({
        url: `/api/inkle/tax_compliance/group/${groupId}/filings_timeline/`,
        params: {
          year,
          ...(entityIds.length > 0 ? { entity_ids: entityIds.join(",") } : {}),
        },
      }),
      providesTags: ["Tasks", "TaskList", "CART"],
    }),
  }),
});

export const {
  useGetFilingsTimelineQuery,
  useGetFilingsTimelineMetaQuery,
  usePrefetch,
} = filingsTimelineApi;
